module.exports = __webpack_public_path__ + "img/s1.bf51a1c0.jpg";